import React from 'react';
import { OrderPage } from '../../pages/Inventory';
import { observer } from 'mobx-react';

const OrderPageContainer = () => {
    return (
        <div>
            <OrderPage/>
        </div>
    )
}

export default observer(OrderPageContainer);